var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpureFillingMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Orena fyllningsmassor"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 27973",
    transform: "translate(21919.589 7318.055)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.702,
    "data-name": "Rena fyllnadsmassor"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4672"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-21899.41-7277.017 3.7 3.607a2.6 2.6 0 0 1 .055 3.663l-8.077 8.315a2.561 2.561 0 0 1-2.326.733l-8.26-1.52a2.625 2.625 0 0 1-2.07-2.032l-1.648-8.077a2.606 2.606 0 0 1 .7-2.326l8.077-8.315a2.619 2.619 0 0 1 3.681-.055l3.626 3.534",
    "data-name": "Path 24252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-21871.737-7310.581-30.273 31.146-3.649 3.753a1.777 1.777 0 0 0 .056 2.532h0a1.777 1.777 0 0 0 2.493-.055l3.689-3.8 30.277-31.145",
    "data-name": "Path 24253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-21865.301-7307.125-5.134-2.283-2.324-4.963a.861.861 0 0 1 .164-.966l1.446-1.488a.862.862 0 0 1 1.219-.017l7.023 6.827a.863.863 0 0 1 .017 1.219l-1.443 1.483a.862.862 0 0 1-.968.188Z",
    "data-name": "Path 24254"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4673"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21898.768-7282.767c-.458-.073-.879-.128-1.319-.2",
    "data-name": "Path 24255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21892.889-7282.328c-.44 0-.88-.018-1.319-.037",
    "data-name": "Path 24256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21872.982-7304.213a11.237 11.237 0 0 0 1.355 1.282c2.308 1.849 5.513 2.564 7.271 4.926 1.355 1.777 1.593 4.14 1.575 6.374-.018 1.337-.641 3.389-2.564 4.01a79.328 79.328 0 0 1-25.513 5.274c-.678.018-1.354.018-2.032.018",
    "data-name": "Path 24257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21900.087-7282.968a68.679 68.679 0 0 1-15.878-4.634 4.461 4.461 0 0 1-2.766-4.23 12.023 12.023 0 0 1 4.615-9.029c1.154-.88 2.455-1.538 3.535-2.51 1.575-1.392 2.6-3.351 4.341-4.524 1.813-1.226 4.157-1.41 6.025-2.564 1.721-1.063 2.857-2.857 4.3-4.286 1.429-1.429 3.534-2.729 5.53-2.4 3.736.623 5.366 5.146 8.59 7.124 1.611.99 3.552 1.282 5.145 2.271a8.758 8.758 0 0 1 1.227.953",
    "data-name": "Path 24258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21905.847-7300.622a10.892 10.892 0 0 0 7.714 2.842",
    "data-name": "Path 24259"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-21888.738-7314.62s-.733 6.535-7.329 3.848",
    "data-name": "Path 40430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21888.678-7314.724s-1.1 4.886 3.97 5.558",
    "data-name": "Path 40431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21890.086-7311.466a1.877 1.877 0 0 0 .209 1.586c.226.347.562.607.821.931a2.608 2.608 0 0 1-1.1 4.068",
    "data-name": "Path 40432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21888.37-7304.003a5.544 5.544 0 0 0-.225-4.1",
    "data-name": "Path 40433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21890.576-7310.44a4.566 4.566 0 0 0-3.275 3.044 16.257 16.257 0 0 0-.38 2.308 3.851 3.851 0 0 1-.891 2.125",
    "data-name": "Path 40434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21896.671-7305.497a3.557 3.557 0 0 1 2.447-1.461",
    "data-name": "Path 40435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21892.91-7308.964a2.487 2.487 0 0 0 1.65 1.9",
    "data-name": "Path 40436"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1468",
    transform: "translate(-21876.465 -7287.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1469",
    transform: "translate(-21868.402 -7294.646)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1470",
    transform: "translate(-21876.82 -7295.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1471",
    transform: "translate(-21883.297 -7286.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1472",
    transform: "translate(-21868.402 -7294.646)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1473",
    transform: "translate(-21876.82 -7295.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1474",
    transform: "translate(-21872.611 -7298.071)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1475",
    transform: "translate(-21872.256 -7292.083)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1476",
    transform: "translate(-21878.674 -7290.907)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1477",
    transform: "translate(-21906.15 -7289.989)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1478",
    transform: "translate(-21899.256 -7295.001)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1479",
    transform: "translate(-21907.674 -7295.825)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.355,
    cy: 0.355,
    r: 0.355,
    strokeWidth: 1.702,
    "data-name": "Ellipse 1480",
    transform: "translate(-21891.287 -7298.907)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpureFillingMaterial);
export default __webpack_public_path__ + "static/media/ImpureFillingMaterial.e74a972ee7f96be2de7cac562128b4a0.svg";
export { ForwardRef as ReactComponent };